import Main from '@/main'
import * as Pages from '@/pages'

export const RoutesNames = {
  ROOT: '/',
  HOME: '/home',
  BLOG: '/blog',
  ONBOARDING_FIRST_PAGE: '/onboarding-first-page',
  PRODUCT_DETAIL: '/product-detail',
  DECLARATON_FACILITATED: '/declaration-facilitated',
  VARIABLE_INCOME: '/variable-income',
  CONSORTIUM: '/consortium',
  PENSION: '/pension',
  GENERIC_DETAIL_PAGE: '/detail',
}

export default [
  { path: RoutesNames.ROOT, exact: true, element: <Main /> },
  { path: RoutesNames.HOME, exact: true, element: <Pages.Home /> },
  { path: RoutesNames.BLOG, exact: true, element: <Pages.Blogs /> },
  { path: RoutesNames.PENSION, exact: true, element: <Pages.Pension /> },
  { path: RoutesNames.CONSORTIUM, exact: true, element: <Pages.Consortium /> },
  { path: RoutesNames.ONBOARDING_FIRST_PAGE, exact: true, element: <Pages.OnBoarding /> },
  { path: RoutesNames.PRODUCT_DETAIL, exact: true, element: <Pages.ProductDetail /> },
  { path: RoutesNames.VARIABLE_INCOME, exact: true, element: <Pages.VariableIncome /> },
  {
    path: RoutesNames.DECLARATON_FACILITATED,
    exact: true,
    element: <Pages.DeclarationFacilitated />,
  },
  { path: RoutesNames.VARIABLE_INCOME, exact: true, element: <Pages.VariableIncome /> },
  { path: RoutesNames.CONSORTIUM, exact: true, element: <Pages.Consortium /> },
  { path: RoutesNames.PENSION, exact: true, element: <Pages.Pension /> },
  { path: RoutesNames.GENERIC_DETAIL_PAGE, exact: true, element: <Pages.GenericDetailPage /> },
]
